export function parseRGB(rgbStr) {
  return rgbStr.match(/\d+/g);
}
